// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:31:55

export default {
  "id": "submarine-attack",
  "slug": "submarine-attack",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/210ba7afd4ad4871b05f4c178b061064-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/210ba7afd4ad4871b05f4c178b061064/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Submarine Attack",
      "description": "Command a submarine, destroy enemy ships with torpedoes, unlock new weapons, and conquer the ocean. Engage in thrilling naval battles, use unique abilities, face numerous enemies, and wield powerful armaments to achieve victory.",
      "instructions": "Mobile: Hold your finger and drag in different directions to aim at the enemy. Press the red button to attack.\nPC (mouse): Hold the mouse button and drag in different directions to aim at the enemy. Press the red button to attack.\nPC(keyboard): Use w,a,s,d or arrows to aim and space to shoot. Use shift to speed up the camera.",
      "genres": [
        "Shooter",
        "Strategy"
      ],
      "tags": [
        "battleship",
        "sea",
        "ship",
        "submarine"
      ]
    },
    "zh-CN": {
      "title": "潜艇攻击",
      "description": "指挥潜艇，用鱼雷摧毁敌舰，解锁新武器，征服海洋。参与激动人心的海战，使用独特能力，面对众多敌人，运用强大武器赢得胜利。",
      "instructions": "移动端：按住手指，向不同方向拖动以瞄准敌人。按下红色按钮攻击。\n\nPC（鼠标）：按住鼠标按钮，向不同方向拖动以瞄准敌人。按下红色按钮攻击。\n\nPC（键盘）：使用W、A、S、D键或箭头键瞄准，空格键射击。使用Shift键加快相机速度。",
      "genres": [
        "射击",
        "策略"
      ],
      "tags": [
        "战舰",
        "海洋",
        "船只",
        "潜艇"
      ]
    },
    "zh-TW": {
      "title": "潛艇攻擊",
      "description": "指揮潛艇，以魚雷擊沉敵艦，解鎖新武器，征服海洋。參與刺激的海戰，使用獨特能力，對抗眾多敵人，並操縱強大的裝備以獲得勝利。",
      "instructions": "行動裝置：握住手指並向不同方向拖動以對準敵人。按下紅色按鈕進行攻擊。\n電腦（滑鼠）：按住滑鼠按鈕並向不同方向拖動以對準敵人。按下紅色按鈕進行攻擊。\n電腦（鍵盤）：使用W、A、S、D或方向鍵對準目標，按空格鍵發射攻擊。使用Shift鍵加快鏡頭移動速度。",
      "genres": [
        "射擊",
        "策略"
      ],
      "tags": [
        "戰艦",
        "海洋",
        "船",
        "潛艇"
      ]
    },
    "zh-HK": {
      "title": "潛艇攻擊",
      "description": "指揮潛艇，用魚雷擊沉敵艦，解鎖新武器，征服海洋。參與刺激的海戰，使用獨特能力，對抗眾多敵人，操縱強大裝備以獲得勝利。",
      "instructions": "手機：按住手指並向不同方向拖動以對準敵人。按紅色按鈕進行攻擊。\n電腦（滑鼠）：按住滑鼠按鈕並向不同方向拖動以對準敵人。按紅色按鈕進行攻擊。\n電腦（鍵盤）：使用 w,a,s,d 或方向鍵對準目標，空格鍵射擊。使用 Shift 鍵加快相機速度。",
      "genres": [
        "射擊",
        "策略"
      ],
      "tags": [
        "戰艦",
        "海",
        "船",
        "潛艇"
      ]
    },
    "ja": {
      "title": "潜水艦攻撃",
      "description": "潜水艦を指揮し、魚雷で敵艦を撃沈し、新しい武器を解禁し、海を征服せよ。刺激的な海戦に参加し、ユニークな能力を使用し、多数の敵に立ち向かい、強力な兵器を駆使して勝利を達成せよ。",
      "instructions": "モバイル: 指を持ち、異なる方向にドラッグして敵に照準を当てる。赤いボタンを押して攻撃する。\nPC（マウス）: マウスボタンを持ち、異なる方向にドラッグして敵に照準を当てる。赤いボタンを押して攻撃する。\nPC（キーボード）: w,a,s,dまたは矢印キーを使って照準を当て、スペースを押して発射する。Shiftキーを使ってカメラのスピードを上げる。",
      "genres": [
        "射撃",
        "戦略"
      ],
      "tags": [
        "戦艦",
        "海",
        "船舶",
        "潜水艦"
      ]
    },
    "ko": {
      "title": "잠수함 공격",
      "description": "잠수함을 지휘하여 적함을 토르페도로 파괴하고, 새로운 무기를 해금하고 바다를 정복하세요. 흥미진진한 해전에 참여하고 독특한 능력을 사용하여 많은 적을 맞아 강력한 무기를 들고 승리를 달성하세요.",
      "instructions": "모바일: 손가락을 눌러 다양한 방향으로 적을 향해 맞추세요. 빨간 버튼을 눌러 공격하세요.\nPC(마우스): 마우스 버튼을 눌러 다양한 방향으로 적을 향해 맞추세요. 빨간 버튼을 눌러 공격하세요.\nPC(키보드): w, a, s, d 또는 방향키로 맞추고 공간키로 발사하세요. Shift 키를 눌러 카메라를 가속화하세요.",
      "genres": [
        "총알게임",
        "전략게임"
      ],
      "tags": [
        "함선",
        "해",
        "배",
        "잠수함"
      ]
    },
    "fr": {
      "title": "Attaque sous-marine",
      "description": "Commandez un sous-marin, détruisez les navires ennemis avec des torpilles, débloquez de nouvelles armes et conquérez l'océan. Engagez-vous dans des batailles navales époustouflantes, utilisez des capacités uniques, affrontez de nombreux ennemis et maniez des armements puissants pour atteindre la victoire.",
      "instructions": "Mobile : Tenez votre doigt et faites glisser dans différentes directions pour viser l'ennemi. Appuyez sur le bouton rouge pour attaquer.\nPC (souris) : Maintenez le bouton de la souris et faites glisser dans différentes directions pour viser l'ennemi. Appuyez sur le bouton rouge pour attaquer.\nPC (clavier) : Utilisez les touches w, a, s, d ou les flèches pour viser et l'espace pour tirer. Utilisez la touche Maj pour accélérer la caméra.",
      "genres": [
        "Tirailleur",
        "Stratégie"
      ],
      "tags": [
        "bataille navale",
        "mer",
        "navire",
        "sous-marin"
      ]
    }
  }
};
